<template>
    <div class="tc-guide-main-container"
         v-on:click.stop="closeGide()">
            <div class="tc-div-contents"
                 v-if="defineUIContext === 'items'">
                <GuideItem :text="'Перетащите комплектующие внутрь шкафа справа.'"
                           :side="'left'"
                           :position="['128px', '300px']"/>
            </div>

            <div class="tc-div-contents"
                 v-if="defineUIContext === 'presets'">
                <GuideItem :text="'Выбрать одно из готовых решений одним нажатием.'"
                           :side="'left'"
                           :position="['128px', '300px']"/>
            </div>

            <div class="tc-div-contents"
                 v-if="defineUIContext === 'project'">
                <GuideItem :text="'Вы можете переключаться между шкафами внутри одного проекта.'"
                           :side="'left'"
                           :position="['128px', '300px']"/>

                <GuideItem :text="'Добавляйте в проект шкафы разных типов и конфигураций'"
                           :text-array="['Внимание! Требуется авторизация']"
                           :side="'left'"
                           :position="['calc(100% - 115px)', '300px']"/>
            </div>

            <GuideItem :text="'Список добавленных комплектующих для текущего шкафа.'"
                       :side="'right'"
                       :position="['55px', 'calc(100% - 655px)']"/>

            <GuideItem :text-array="[
                        'Это Ваш шкаф.',
                        'Перетащите в него комплектующие из меню слева, чтобы добавить в конфигурацию.',
                        'Для удаления комплектующих, перетащите их наружу из шкафа или нажмите клавишу “Delete”.']"
                       :side="'left'"
                       :position="['calc(50% - 80px)', '50%']"/>

            <GuideItem :text="'Скачать спецификацию или оформить заказ.'"
                       :side="'right'"
                       :position="['calc(100% - 185px)', 'calc(100% - 655px)']"/>
    </div>
</template>

<script>


import { useStoreUI } from '@/Store/storeUI';
import GuideItem from '@/UI/Guide/GuideItem.vue';
import { defineUIContext } from '@/libs/defineUIContext';

export default {
    name: 'TheGuide',
    components: { GuideItem },
    setup() {
        const storeUI = useStoreUI();

        return {
            storeUI,
        };
    },
    methods: {
        closeGide() {
            this.storeUI.setIsGuide(false);
        },
    },
    computed: {
        defineUIContext,
    },
};
</script>

<style scoped lang="scss">
.tc-guide-main-container {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #00000033;
    z-index: 2000;
    pointer-events: all;
    padding: 15px;
    box-sizing: border-box;
    overflow: hidden;
    display: grid;
    grid-template-rows: auto max-content;
}

.tc-guide-bot {
    display: flex;
    justify-content: center;
    align-items: center;
    height: max-content;
    width: 100%;
    box-sizing: border-box;
    gap: 10px;
}

</style>
